
$(document).ready(function(){
	init_typecat_sel();
	onTeisesAktaiChangeType();
	init_acts();
	actsListControl();
});

function init_teises_aktai()
{
//	init_typecat_sel();
//	$('#search_category').select2("val", $('#search_category').attr('rel'));
//	onTeisesAktaiChangeType();
}


function init_typecat_sel()
{
	if ($('#sort_id').val() == -1){
		$("#type_id").prop('disabled', true);
		$(".type_title").addClass('blur');
	}
	$('#sort_id').on('change', function (){
		if ($('#sort_id').val() == -1){
			$("#type_id").prop('disabled', true);
			$(".type_title").addClass('blur');
		}else{
			$("#type_id").prop('disabled', false);
			$(".type_title").removeClass('blur');
		}
	});		
}

function onTeisesAktaiChangeType()
{
	$("#text_incontent, #text_intitle").prop('disabled', true);
	
	$('#incontent').on('keyup blur', function(){
		if($(this).val().length > 0) {
			$("#text_incontent").prop('disabled', false);
		} else {
			$("#text_incontent").prop('disabled', true);
		}
	});
	$('#intitle').bind('keyup blur', function(){
		if($(this).val().length > 0) {
			$("#text_intitle").prop('disabled', false);
		} else {
			$("#text_intitle").prop('disabled', true);
		}
	});
	
	$('#incontent, #intitle').keyup();
}

function init_acts() {
	
	$('.category').click(function(){		
		$(this).parent().find('.category_questions').slideToggle();
		$(this).children('.catNameOuter').toggleClass('act');
	});
	
	$('.question').click(function(){
		$(this).parent().find('.answer').slideToggle();
		$(this).children('.questionNameOuter').toggleClass('act');
	});
	//form
	if (localStorage.getItem('filterState') === 'active') {
		$('.toggle-search-filters').addClass('active').parents('form').find('.toggable-filter').show();
	}

	$('.toggle-search-filters').on('click keydown', function(e){
		if(e.type == 'click' || e.keyCode == 13) {
			e.preventDefault();

			$(this).toggleClass('active').parents('form').find('.toggable-filter').toggle();

			if ($(this).hasClass('active')) {
				localStorage.setItem('filterState', 'active');
			} else {
				localStorage.removeItem('filterState');
			}
		}
	});

	$('.reset').on('click', function(e) {
		localStorage.removeItem('filterState');

		$('.toggle-search-filters').removeClass('active').parents('form').find('.toggable-filter').hide();
	});
}

function actsListControl() {
	if($(".acts-list .single_act").length > 0) {
		$(".acts-list .single_act .toggle-act-description").on('click keydown', function(e) {
			if(e.type == 'click' || e.keyCode == 13) {
				$(this).parents('.single_act').toggleClass('active').find('.toggable-part').slideToggle('slow');
			}
		})
	}
}